<template>
  <v-dialog :retain-focus="false" :value="sectionEditor.show" :width="1100" @input="handleClosePopup">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields.title }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-4">
          <label class="label-input">Section Name</label>
          <v-text-field v-model="fields.title" hide-details />
        </div>

        <SectionLayout :settings="fields.settings" :container-page="fields.containerPage" />

        <div class="mb-5">
          <label class="label-input">Hero Title</label>
          <div class="group-item">
            <ckeditor :editor="editor" v-model="fields.cardTitle.content" :config="editorConfig" />
          </div>
        </div>

        <div class="mb-5">
          <label class="label-input">Grid Settings</label>
          <div class="group-item">
            <v-row>
              <v-col cols="12" md="4">
                <label>Columns Per View</label>
                <v-select
                  v-model.number="fields.listItem.colPerView"
                  :items="[2, 3, 4, 5, 6]"
                  hide-details
                  class="mt-0"
                />
              </v-col>
              <v-col cols="12" md="4">
                <ColorPicker
                  :value="fields.listItem.bgColorItem"
                  name="bg-color-item"
                  label="Item Background"
                  default-color="#006196"
                  @input="value => (fields.listItem.bgColorItem = value)"
                />
              </v-col>
              <v-col cols="12" md="4">
                <ColorPicker
                  :value="fields.listItem.borderColorItem"
                  name="border-color-item"
                  label="Item Border Color"
                  default-color="#006196"
                  @input="value => (fields.listItem.borderColorItem = value)"
                />
              </v-col>
            </v-row>
          </div>
        </div>

        <div class="mb-5">
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input mb-0">Grid Items</label>
            <v-btn small color="primary" @click="handleAddItem">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Item</span>
            </v-btn>
          </div>
          <v-expansion-panels accordion>
            <v-expansion-panel v-for="(item, index) in fields.items" :key="`grid-item-${index}`">
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center" style="width: 100%">
                  <span>Item {{ index + 1 }}</span>
                  <v-btn icon :disabled="fields.items.length <= 1" @click.stop="handleRemoveItem(index)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div class="mb-3">
                  <label>Icon Image</label>
                  <UploadImage
                    :image="{ imageSrc: item.image }"
                    :height="`150`"
                    :typeUpload="'image'"
                    @callback="obj => (item.image = obj.imageSrc)"
                    @callbackDelete="item.image = ''"
                  />
                </div>
                <div>
                  <label>Content</label>
                  <ckeditor :editor="editor" v-model="item.content" :config="editorConfig" />
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import { cloneDeep } from 'lodash';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import { updateHtmlFromData } from '../common/html/update';
import UploadImage from '../common/form/upload-file/upload-image.vue';
import SectionLayout from '../common/ui-modules/section-layout/editor.vue';
import ColorPicker from '../common/ui-modules/inputs/color-picker.vue';

const defaultItemImage =
  'https://cdn.skyfastimg.com/6a0ee559dc2c2e000934dd37/2026/06/23/image-6a39f221293fc4c9d3a3e40a.png';

const buildItemDefault = () => ({
  image: defaultItemImage,
  content: '<h3>Plantar Fasciitis</h3><p>Sharp heel pain caused by micro-tears from poor arch support.</p>',
});

const getDefaultFields = () => ({
  title: 'Icon Grid With Hero Text Conven Feet Section',
  settings: {
    paddingTop: true,
    paddingBottom: true,
    backgroundColor: '#FFFFFF',
    textColor: '#000000',
    overlayColor: '#000000',
    overlayOpacity: 0,
    showOverlay: false,
    backgroundImage: '',
    useCustomWidth: false,
    customWidth: 1204,
  },
  containerPage: {
    enableStyle: false,
    background: '#FFFFFF',
  },
  cardTitle: {
    content:
      '<h2 style="text-align: center;">Why Your Feet Are Screaming For Help?</h2><p style="text-align: center;">75% of adults will experience debilitating foot pain at some point. It\'s not just "getting old"</p><p style="text-align: center;">It\'s a sign that your foundation is collapsing!!!</p><p style="text-align: center;">you recognize any of these symptoms, your current footwear is likely causing permanent damage.</p>',
  },
  listItem: {
    colPerView: 4,
    bgColorItem: '#006196',
    borderColorItem: '#006196',
  },
  items: [buildItemDefault(), buildItemDefault(), buildItemDefault(), buildItemDefault()],
});

export default {
  name: 'IconGridWithHeroTextConvenFeetSectionEditor',
  components: { UploadImage, SectionLayout, ColorPicker },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: getDefaultFields(),
    };
  },
  mounted() {
    const def = getDefaultFields();
    const extract = cloneDeep(this.sectionEditor.sectionExtract || {});

    this.fields = {
      ...def,
      ...extract,
      settings: { ...def.settings, ...(extract.settings || {}) },
      containerPage: { ...def.containerPage, ...(extract.containerPage || {}) },
      cardTitle: { ...def.cardTitle, ...(extract.cardTitle || {}) },
      listItem: { ...def.listItem, ...(extract.listItem || {}) },
      items: Array.isArray(extract.items) && extract.items.length ? extract.items : def.items,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionIconGridWithHeroTextConvenFeet(
        this.sectionEditor.section.html,
        this.fields,
      );
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields.title,
        html: updateHtml,
      });
      this.$emit('close');
    },
    handleAddItem() {
      this.fields.items.push(cloneDeep(buildItemDefault()));
    },
    handleRemoveItem(index) {
      if (this.fields.items.length <= 1) return;
      this.fields.items.splice(index, 1);
    },
  },
};
</script>

<style lang="scss" scoped>
.group-item {
  border: 1px solid #0000000f;
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
}
.ck-editor__editable_inline,
.ck-editor__editable {
  min-height: 140px;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}
</style>
